import clsx from 'clsx'

export const NOL = () => <p className={clsx('font-light text-gray-500 focus-within:outline-none italic')}>NULL</p>
